import { isTextHebrew } from '@wix/wix-chatbot-common/locale';
import { useMemo } from 'react';

export const useIsRtlText = (text: string) => {
  return useMemo(() => isTextHebrew(text), [text]);
};
